@if (cart$ | async) {
  <div
    class="fixed bottom-0 left-0 right-0 w-full shadow shadow-top"
    [style.z-index]="50"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    appFooterStickyModal
  >
    <div class="mx-auto">
      @if ((hideCartParameters$ | async) === false) {
        <div>
          <app-cart-parameters-overview
            [iconBackgroundColor]="iconBackgroundColor"
            [iconColor]="iconColor"
            [textColor]="labelColor"
          ></app-cart-parameters-overview>
        </div>
      }
      @if ((cartProducts$ | async)?.length) {
        @let totalCartUnits = (cartLineItemsTotalQuantity$ | async) ?? 0;
        <div
          class="flex w-full items-center px-3 pb-3 kiosk:px-12 kiosk:py-8"
          [class.pb-6]="isNotched"
          [class.pt-2]="hideCartParameters$ | async"
        >
          <div class="flex-1">
            <app-cart-footer-button-atom
              data-testid="view-basket-button"
              [label]="
                ('shop-page.view-basket' | translate) +
                ' (' +
                totalCartUnits +
                ' ' +
                (totalCartUnits > 1
                  ? ('shop-page.item-plural' | translate)
                  : ('shop-page.item-singular' | translate)) +
                ')'
              "
              [disabled]="isNavigationToCartInProgress"
              [iconUrl]="isNavigationToCartInProgress ? 'assets/images/spinner.svg' : ''"
              [icon]="!isNavigationToCartInProgress ? 'icon-shopping-bag' : ''"
              [buttonBackgroundColor]="buttonBackgroundColor"
              [buttonTextColor]="buttonTextColor"
              (click)="navigateToCart()"
            ></app-cart-footer-button-atom>
          </div>
          @if (order$ | async; as order) {
            <div class="ml-7.5 hidden xm:block">
              <app-price-atom
                [format]="true"
                [amount]="order?.final_price ?? 0"
              ></app-price-atom>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
